import {createFileRoute} from '@tanstack/react-router'

import {RentalAssetTypesPage} from '../../../../assets/rental-assets/rental-asset-types-page'

export const Route = createFileRoute('/_app/rental-assets/types/')({
    component: RentalAssetTypesRoute,
})

function RentalAssetTypesRoute() {
    return <RentalAssetTypesPage />
}
